export default __webpack_public_path__ + "static/media/QRYPTO_QUEENS_LOGO__COLORS_7.a5805afd.png";